import { useMemo } from 'react';
import { Design, DraftDesignConfiguration, PixelDesign } from '@/types';
import { DESIGN_MIN_SIZE } from '@/utils/masks/constants';
import { getIsFilterSupported } from '@/features/filters/getIsFilterSupported';
import { isPixelDesign } from '@/model/design/isDesignType';
import { isUploadedDesign } from '@/model/design/isUploadedDesign';
import { getIsDieCutStickerPrintType } from '@/model/printType/getIsDieCutStickerPrintType';
import { getIsScreenPrintType } from '@/model/printType/getIsScreenPrintType';

const isMaskPossible = (design: Design): design is PixelDesign =>
  isUploadedDesign(design) &&
  isPixelDesign(design) &&
  Math.min(design.size.width, design.size.height) >= DESIGN_MIN_SIZE; // has the necessary minimum size

export function useMasksAndFiltersAvailable(configuration: DraftDesignConfiguration) {
  const { design, printType } = configuration;
  const printTypePreventsImageEffects =
    getIsScreenPrintType(printType) || getIsDieCutStickerPrintType(printType);

  return useMemo(() => {
    if (printTypePreventsImageEffects) {
      return [false, false];
    }

    const isMaskAvailable = isMaskPossible(design);
    return [isMaskAvailable, isMaskAvailable && getIsFilterSupported()];
  }, [design, printTypePreventsImageEffects]);
}
